import { shallowMount } from "@vue/test-utils";
import DocumentType from "@/components/core/composite/combos/DocumentType";

describe("DocumentType component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(DocumentType);
  });

  it("Renders del component DocumentType", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
